/* Etiqueta del cursor: «Ver producto» acompaña al ratón sobre la foto de una
   tarjeta de producto (cualquier `[data-cursor-label]`). Una sola etiqueta
   para toda la página, pintada en layout/theme.liquid; el estilo vive en
   components.css (`.cursor-label`).

   Solo con ratón: en táctil no hay hover. Se esconde al salir de la foto (la
   cesta de la tarjeta queda fuera, así que sobre ella no sale), al hacer
   scroll y mientras haya un <dialog> abierto. */
(() => {
  const tip = document.querySelector('[data-cursor-label-tip]');
  if (!tip || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  let visible = false;
  const hide = () => {
    if (!visible) return;
    visible = false;
    tip.classList.remove('is-visible');
  };

  tip.hidden = false;
  document.addEventListener(
    'pointermove',
    (event) => {
      const over =
        event.pointerType === 'mouse' &&
        event.target instanceof Element &&
        event.target.closest('[data-cursor-label]') &&
        !document.querySelector('dialog[open]');
      if (!over) return hide();
      tip.style.setProperty('--cursor-x', event.clientX);
      tip.style.setProperty('--cursor-y', event.clientY);
      if (!visible) {
        visible = true;
        tip.classList.add('is-visible');
      }
    },
    { passive: true }
  );
  window.addEventListener('scroll', hide, { passive: true });
  document.documentElement.addEventListener('pointerleave', hide);
  window.addEventListener('blur', hide);
})();
